import errorMap from "@gap/backend/util/validations/validation-error-map"
import { z } from "zod"

export const vimeoUrlBases = ['https://player.vimeo.com/video/', 'https://vimeo.com/'] as const
export type VimeoUrl = `${(typeof vimeoUrlBases)[number]}${string}`

class VimeoUrlValidationError extends Error {
   constructor() {
      super('Not a valid Vimeo video URL')
   }
}

export const vimeoUrlSchema = z.string({ errorMap })
   .refine((url) => vimeoUrlBases.some((base) => url.startsWith(base)), { message: 'Invalid Vimeo URL' })
   .transform((url) => url as `${(typeof vimeoUrlBases)[number]}${string}`)
   .optional()

export function validateVimeoUrl(url: string) {
   if (!vimeoUrlBases.find(vimeoUrlBase => url.startsWith(vimeoUrlBase))) {
      throw new VimeoUrlValidationError()
   }

   return url as VimeoUrl
}

export const optionalVimeoUrlValidator = (value: string | undefined, context: z.RefinementCtx): void => {
   if (!value) {
      return
   }
   try {
      validateVimeoUrl(value)
      return
   } catch {}

   context.addIssue({
      code: 'custom',
      message: `* Must match ${vimeoUrlBases.map(pattern => `${pattern}...`).join(' or ')}`,
   })
}